module.exports = __webpack_public_path__ + "static/media/pokemon.6058de96.svg";